import { render, staticRenderFns } from "./restDaySet.vue?vue&type=template&id=049efbdd&scoped=true&"
import script from "./restDaySet.vue?vue&type=script&lang=js&"
export * from "./restDaySet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049efbdd",
  null
  
)

export default component.exports